var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.texts),function(text,idx){return _c('p',{key:idx},[_vm._v("\n    "+_vm._s(text)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }